import { recordReleaseViews } from '@hub/utils/react-query/query-functions';
import { useMutation } from '@tanstack/react-query';

export const useRecordReleaseViews = () => {
  return useMutation<void, Error, string[]>({
    mutationFn: recordReleaseViews,
  });
};
